/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Github_NudgeInputs */



/**
* | output |
* | --- |
* | "Link your GitHub account so we can mention you and you can follow your report." |
*
* @param {Feedback_Github_NudgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_github_nudge = /** @type {((inputs?: Feedback_Github_NudgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Github_NudgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liez votre compte GitHub pour que nous puissions vous mentionner et suivre votre signalement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincule su cuenta de GitHub para que podamos mencionarle y pueda seguir su informe.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincule sua conta do GitHub para que possamos mencioná-lo e você possa acompanhar seu feedback.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega il tuo account GitHub così possiamo menzionarti e puoi seguire la tua segnalazione.")
	return /** @type {LocalizedString} */ ("Link your GitHub account so we can mention you and you can follow your report.")
});